<template>
    <Row type="none" class="bg-white rounded shadow">

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <div v-if="alertInvalidImage"  class="container">
            <Alert class="text-center" :variant="'danger'">{{ alertText }}</Alert>
        </div>

        <div class="grid grid-cols-12 gap-3 container pt-4">
            <div class="col-span-12 md:col-span-6 relative pl-0 mt-3">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute bottom-9 ml-2">
                    {{ $t('product.name') }}<span class="text-red-500 text-xl">*</span>
                </div>
                <InputBox
                    class="px-0"
                    model-name="name"
                    check-to-model="modelNotEmptyState"
                    :model-form="modelForm"
                    :errors="errors"
                    :no-margin-top="true"
                />
            </div>

            <div class="col-span-12 md:col-span-6 relative pl-0 mt-3">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute bottom-9 ml-2">
                    {{ $t("unitOfMeasure.choose") }}<span class="text-red-500 text-xl">*</span>
                </div>
                <b-form-input list="my-list-id" v-model="modelForm.unitOfMeasure" class="h-11 border-gray-300 focus:ring-0"></b-form-input>
                <datalist id="my-list-id">
                    <option
                        v-for="(item, index) in unitOfMeasures" :key="index"
                    >
                        {{ item.name }}
                    </option>
                </datalist>
            </div>

            <div class="col-span-12 md:col-span-6 relative pl-0 mt-3">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute bottom-9 ml-2">
                    {{ $t('product.barcode') }}
                </div>
                <b-form-input
                    class="h-11 border-gray-300 focus:ring-0"
                    v-model="modelForm.barCode"
                    type="number"
                    @input="controlBarCode"
                    :state="this.statusBarCode"
                    :formatter="formatBarCode"
                    aria-describedby="input-live-feedback"
                    trim
                />
                <b-form-invalid-feedback id="input-live-feedback">
                    {{ $t('product.formatBarcode') }}
                </b-form-invalid-feedback>
            </div>

            <div class="col-span-12 md:col-span-6 relative pl-0 mt-3">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute bottom-9 ml-2">
                    {{ $t('sale.tax.title') }}
                </div>
                <v-select
                    class="px-0"
                    :placeholder="$t('sale.tax.withoutTax')"
                    :options="getTaxes"
                    :get-option-label="option => option['@id'] === null ? option.name : option.name + ' ' + parseFloat(option.percent) + '%'"
                    :reduce="options => options['@id']"
                    v-model="modelForm.tax"
                >
                    <template #no-options="{}">
                        {{ $t("selectError") }}
                    </template>
                </v-select>
            </div>

            <div class="col-span-12 md:col-span-6 relative pl-0 mt-3">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute bottom-9 ml-2">
                    {{ $t('sellingPrice') }}
                </div>
                <InputBox
                    class="px-0"
                    model-name="sellingPrice"
                    check-to-model="modelNotEmptyState"
                    :model-form="modelForm"
                    :errors="errors"
                    :no-margin-top="true"
                />
            </div>

            <div class="col-span-12 md:col-span-6 relative pl-0 mt-3">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute bottom-9 ml-2">
                    {{ $t('currencyRate.choose') }}
                </div>
                <b-form-select
                    class="h-11 border-gray-300 focus:ring-0"
                    v-model="modelForm.sellingPriceCurrencyId">
                    <b-form-select-option :value="3">UZS</b-form-select-option>
                    <b-form-select-option :value="1">USD</b-form-select-option>
                    <b-form-select-option :value="2">RUB</b-form-select-option>
                </b-form-select>
            </div>
        </div>

        <div class="container pr-3 pt-4">
            <CurrencyCollapse :is-bg-white="true">
                <div class="grid grid-cols-10 gap-3">
                    <div class="col-span-12 sm:col-span-2 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute -top-3 ml-2">
                            {{ $t('image.choiceImageFile') }}
                        </div>

                        <label for="image" class="rounded w-full h-28 flex justify-content-center align-items-center" style="border: 1px solid #e0e0e1">

                            <img v-if="!isLoadingError" src="/images/imageIcon.png" alt="" class="h-11 cursor-pointer block">
                            <span
                                v-if="isLoadingError"
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                            >
                            </span>

                            <div
                                v-if="modelForm.image && !isLoadingError"
                                class="absolute text-main bottom-3"
                            >
                                {{ file.name }}
                            </div>
                        </label>
                        <input
                            id="image"
                            style="display: none"
                            type="file"
                            :disabled="modelForm.product === null"
                            accept="image/*"
                            @change="importImage($event)"
                        >
                    </div>
                    <div class="col-span-12 sm:col-span-8 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute -top-3 ml-2">
                            {{ $t('additionalInformation') }}
                        </div>
                        <textarea
                            v-model="modelForm.additionalInformation"
                            class="h-28 border-gray-300 rounded w-full"
                        />
                    </div>
                </div>

                <div class="grid grid-cols-12">
                    <div class="col-span-12 relative pl-0 mt-3">
                        <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute -top-1 ml-2">
                            {{ $t('category') }}
                        </div>
                        <TreeCheckBox
                            class="px-0"
                            model-name="categories"
                            :model-form="modelForm"
                            :options="getProductCategoriesTree"
                            :errors="errors"
                        />
                    </div>
                </div>

                <div class="container text-center font-bold text-gray-500 my-3">
                    {{ $t('unitOfMeasure.additionalUnitOfMeasurement') }}
                </div>

                <div v-for="(unit, index) in moreUnitOfMeasure" :key="index" class="grid grid-cols-12 gap-3">
                        <div class="col-span-11 sm:col-span-6 relative pl-0 mt-3">
                            <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute bottom-9 ml-2">
                                {{ $t('unitOfMeasure.unitOfMeasure') }}
                            </div>
                            <b-form-input class="h-11 border-gray-300 focus:ring-0" list="my-datalist" v-model="unit.unitOfMeasure"></b-form-input>
                            <datalist id="my-datalist">
                                <option
                                    v-for="(itemUnit, indexItem) in unitOfMeasures" :key="indexItem"
                                >
                                    {{ itemUnit.name }}
                                </option>
                            </datalist>
                        </div>

                        <div class="col-span-1 relative flex justify-content-center mt-10">
                            <img src="/images/equal-to.png" alt="" class="h-11 absolute bottom-1">
                        </div>

                        <div class="col-span-9 sm:col-span-3 relative pl-0 mt-3">
                            <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute bottom-9 ml-2">
                                {{ $t('unitOfMeasure.comparison') }}
                            </div>
                            <input
                                class="form-control h-11 border-gray-300 focus:ring-0 d-inline"
                                type="number"
                                min="0"
                                v-model="unit.howMany"
                            />
                        </div>

                        <div class="col-span-1 flex items-center font-bold pl-0 mt-3">
                            {{ modelForm.unitOfMeasure }}
                        </div>

                        <div class="col-span-1 relative pl-0 mt-3">
                            <img v-if="!index" @click="addMore" src="/images/more.png" alt="" class="h-11 cursor-pointer">
                            <img v-if="index" @click="deleteOne(index)" src="/images/minus.png" alt="" class="h-11 cursor-pointer">
                        </div>
                    </div>
            </CurrencyCollapse>
        </div>

        <div class="container py-4">
            <SubmitRow
                v-if="canManageProducts()"
                :is-disabled="hasErrors"
                :is-loading="isLoading"
                :do-action="add"
                :text="submitButtonName"
            />
        </div>

        <div v-if="hasProductPurchaseHistory">
            <table class="w-full">
                <thead>
                    <tr class="bg-lightGray h-11 font-bold">
                        <th class="d-none d-md-table-cell pl-3"> #</th>
                        <th>{{ $t('date') }}</th>
                        <th>{{ $t('purchasePerUnit') }}</th>
                        <th>{{ $t('product.productAmount') }}</th>
                        <th class="d-none d-sm-table-cell">{{ $t('totalPrice') }}</th>
                        <th class="d-none d-xl-table-cell">{{ $t('payed') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(purchase, index ) of getProductPurchaseHistory" :key="index" class="h-11">
                        <td class="d-none d-md-table-cell pl-3">{{ purchase.id }}</td>
                        <td>{{ dateTimeFormat(purchase.createdAt, true) }}</td>
                        <td>{{ showCurrencyById(purchase.currency.id, purchase.pricePerUnit) }}</td>
                        <td>{{ purchase.amount }} {{ showUnitOfMeasure(purchase.product.unitOfMeasure) }}</td>
                        <td class="d-none d-sm-table-cell">
                            {{ showCurrencyById(purchase.currency.id, purchase.totalPrice) }}
                        </td>
                        <td v-if="purchase.payedAmount > 0" class="d-none d-xl-table-cell">
                            {{ showCurrencyById(purchase.currency.id, purchase.payedAmount) }}
                        </td>
                        <td v-else class="d-none d-xl-table-cell"> - </td>
                    </tr>
                </tbody>
            </table>

            <Pagination
                class="pl-3 py-4"
                :search="productHistory"
                :base-url="'products/' + this.productHistory.productId"
                :total-items="getProductPurchaseHistoryTotalCount"
                method-name="fetchProductPurchaseHistory"/>
        </div>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import Row from "../../components/html/Row";
import InputBox from "../../components/InputBox";
import SubmitRow from "../../components/SubmitRow";
import accessMixin from "@/mixin/accessMixin";
import TreeCheckBox from "@/components/TreeCheckBox";
import Modal from "@/components/html/Modal";
import Alert from "@/components/html/Alert";
import Pagination from "@/components/html/Pagination";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import vSelect from 'vue-select'
import '../../style/vue-select.css';
import CurrencyCollapse from "@/components/CurrencyCollapse.vue";

export default {
    name: "ProductsAdd",
    components: {
        CurrencyCollapse,
        Pagination,
        Alert,
        TreeCheckBox,
        SubmitRow,
        InputBox,
        Row,
        Modal,
        vSelect
    },
    mixins: [validatorMixin, accessMixin, dateFormattingMixin, currencyFormatMixin, currencyRateMixin],
    data() {
        return {
            hasProductPurchaseHistory: false,
            statusBarCode: null,
            alertInvalidImage: false,
            alertText: '',
            isLoadingError: false,
            submitButtonName: 'add',
            modalText: '',
            isLoading: false,
            productHistory: {
                page: 1,
                productId: null
            },
            moreUnitOfMeasure: [{
                product: '',
                howMany: '',
                unitOfMeasure: ''
            }],
            errors: {
                name: null,
                sellingPrice: null,
                sellingPriceCurrencyId: null,
                unitOfMeasure: null,
                barcode: null,
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'product.title', url: 'products'},
                {name: this.$route.params.id ? 'edit' : 'add'},
            ],
            modelForm: {
                tax: null,
                id: null,
                name: '',
                sellingPrice: '',
                barCode: null,
                sellingPriceCurrencyId: 0,
                unitOfMeasure: '',
                image: null,
                categories: [],
                additionalInformation: ''
            },
        }
    },
    computed: {
        ...mapGetters([
            'getWarehouses',
            'getProduct',
            'getProductCategoriesTree',
            'getProductPurchaseHistory',
            'getProductPurchaseHistoryTotalCount',
            "getTaxes"
        ]),
        unitOfMeasures() {
            return [
                // pic
                {id: "pc", name: this.$t("unitOfMeasure.pc")},

                // weight
                {id: "g", name: this.$t("unitOfMeasure.g")},
                {id: "kg", name: this.$t("unitOfMeasure.kg")},

                // liquid
                {id: "ml", name: this.$t("unitOfMeasure.ml")},
                {id: "l", name: this.$t("unitOfMeasure.l")},

                // length
                {id: "mm", name: this.$t("unitOfMeasure.mm")},
                {id: "cm", name: this.$t("unitOfMeasure.cm")},
                {id: "m", name: this.$t("unitOfMeasure.m")},
                {id: "km", name: this.$t("unitOfMeasure.km")},
                {id: "ft", name: this.$t("unitOfMeasure.ft")},

                // cubic meter
                {id: "m3", name: this.$t("unitOfMeasure.m3")},
            ]
        },
    },
    methods: {
        ...mapActions([
            'pushProductImage',
            'fetchProducts',
            'fetchProductCategoriesTree',
            'pushProduct',
            'fetchProduct',
            'pushAdditionalUnitOfMeasure',
            'fetchProductPurchaseHistory',
            'fetchAllTaxes',
            'setBreadcrumbItems'
        ]),
        deleteOne(index) {
            this.moreUnitOfMeasure.splice(index, 1)
        },
        addMore() {
            this.moreUnitOfMeasure.push({
                product: '',
                howMany: '',
                unitOfMeasure: ''
            })
        },
        formatBarCode(e) {
            return String(e).substring(0, 20);
        },
        controlBarCode() {
            if (this.modelForm.barCode.length >= 7 || this.modelForm.barCode.length === 0) {
                this.statusBarCode = null
                this.errors.barcode = null
            } else {
                this.statusBarCode = false
                this.errors.barcode = false
            }
        },
        changeValueUnitOfMeasure() {
            switch (this.modelForm.unitOfMeasure) {
                case this.$t("unitOfMeasure.pc") :
                    this.modelForm.unitOfMeasure = 'pc'
                    break
                case this.$t("unitOfMeasure.g") :
                    this.modelForm.unitOfMeasure = 'g'
                    break
                case this.$t("unitOfMeasure.kg") :
                    this.modelForm.unitOfMeasure = 'kg'
                    break
                case this.$t("unitOfMeasure.ml") :
                    this.modelForm.unitOfMeasure = 'ml'
                    break
                case this.$t("unitOfMeasure.l") :
                    this.modelForm.unitOfMeasure = 'l'
                    break
                case this.$t("unitOfMeasure.mm") :
                    this.modelForm.unitOfMeasure = 'mm'
                    break
                case this.$t("unitOfMeasure.cm") :
                    this.modelForm.unitOfMeasure = 'cm'
                    break
                case this.$t("unitOfMeasure.m") :
                    this.modelForm.unitOfMeasure = 'm'
                    break
                case this.$t("unitOfMeasure.km") :
                    this.modelForm.unitOfMeasure = 'km'
                    break
                case this.$t("unitOfMeasure.ft") :
                    this.modelForm.unitOfMeasure = 'ft'
                    break
                case this.$t("unitOfMeasure.m3") :
                    this.modelForm.unitOfMeasure = 'm3'
                    break
                default:
                    break
            }
        },
        add() {
            if (this.modelForm.barCode === '') {
                this.modelForm.barCode = null
            }

            this.changeValueUnitOfMeasure()
            this.isLoading = true

            this.pushProduct(this.modelForm)
                .then(response => {
                    this.isLoading = false
                    let data = {}

                    for (let productUnitOfMeasure of this.moreUnitOfMeasure) {
                        if (productUnitOfMeasure.howMany !== '') {
                            if (this.$route.params.id) {
                                productUnitOfMeasure.product = this.getProduct['@id']
                            } else {
                                productUnitOfMeasure.product = response['@id']
                            }

                            data.product = productUnitOfMeasure.product
                            data.howMany = parseInt(productUnitOfMeasure.howMany)
                            data.unitOfMeasure = productUnitOfMeasure.unitOfMeasure

                            this.pushAdditionalUnitOfMeasure(data)
                        }
                    }

                    this.$i18nHelper.toUrl('products')
                })
                .catch((reason) => {
                    this.isLoading = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        },
        importImage(event) {
            this.alertInvalidImage = false
            this.isLoadingError = true
            this.file = event.target.files[0]
            const data = new FormData();
            data.append('file', this.file)

            this.pushProductImage(data)
                .then((res) => {
                    this.modelForm.image = res['@id']
                    setTimeout(() => this.isLoadingError = false, 3000)
                })
                .catch((err) => {
                    this.isLoadingError = false;

                    if (err === 'file: Please upload a valid image') {
                        this.alertText = this.$t('image.validImage')
                    } else {
                        this.alertText = err
                    }

                    this.alertInvalidImage = true
                    this.file = null
                })
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchProductCategoriesTree(null)
        this.fetchAllTaxes({page: null})

        if (this.$route.params.id) {
            this.productHistory.productId = this.$route.params.id

            this.fetchProductPurchaseHistory(this.productHistory)
                .then(() => {
                    this.hasProductPurchaseHistory = true
                })

            this.fetchProduct(this.$route.params.id)
                .then(() => {
                    if (this.getProduct) {
                        this.submitButtonName = 'edit'
                        this.modelForm.id = this.getProduct.id
                        this.modelForm.name = this.getProduct.name
                        this.modelForm.sellingPrice = this.getProduct.sellingPrice

                        if (this.getProduct.barCode !== null) {
                            this.modelForm.barCode = this.getProduct.barCode
                        }

                        this.modelForm.sellingPriceCurrencyId = this.getProduct.sellingPriceCurrency.id
                        this.modelForm.additionalInformation = this.getProduct.additionalInformation
                        switch (this.getProduct.unitOfMeasure) {
                            case 'pc' :
                                this.modelForm.unitOfMeasure = this.$t("unitOfMeasure.pc")
                                break
                            case 'g' :
                                this.modelForm.unitOfMeasure = this.$t("unitOfMeasure.g")
                                break
                            case 'kg':
                                this.modelForm.unitOfMeasure = this.$t("unitOfMeasure.kg")
                                break
                            case 'ml':
                                this.modelForm.unitOfMeasure = this.$t("unitOfMeasure.ml")
                                break
                            case 'l' :
                                this.modelForm.unitOfMeasure = this.$t("unitOfMeasure.l")
                                break
                            case 'mm':
                                this.modelForm.unitOfMeasure = this.$t("unitOfMeasure.mm")
                                break
                            case 'cm':
                                this.modelForm.unitOfMeasure = this.$t("unitOfMeasure.cm")
                                break
                            case 'm' :
                                this.modelForm.unitOfMeasure = this.$t("unitOfMeasure.m")
                                break
                            case 'km':
                                this.modelForm.unitOfMeasure = this.$t("unitOfMeasure.km")
                                break
                            case 'ft':
                                this.modelForm.unitOfMeasure = this.$t("unitOfMeasure.ft")
                                break
                            case 'm3':
                                this.modelForm.unitOfMeasure = this.$t("unitOfMeasure.m3")
                                break
                            default:
                                this.modelForm.unitOfMeasure = this.getProduct.unitOfMeasure
                                break
                        }

                        for (let category of this.getProduct.categories) {
                            this.modelForm.categories.push(category['@id'])
                        }
                    }
                })
        }
    },
}
</script>

<style scoped>

</style>